import { css } from '@emotion/css';

import { LineColors } from '../../styles/styleConstants';

export const Divider = css`
  background-color: ${LineColors.gray_light};
  flex-grow: 0;
`;
